<template>
  <component :is="hasMultipleGroups ? 'v-menu' : 'div'">
    <template v-if="hasMultipleGroups" v-slot:activator="{ on }">
      <div v-on:dblclick.once="on.click" @dblclick="$emit('click-criteria', criterio)">
        <new-criterio-card-inner
          :criterio="criterio"
          :is-dragged="isDragged"
          :show-badge="showBadge"
          @dragstart="$emit('dragstart', criterio, group)"
          @dragend="$emit('dragend')"
        />
      </div>
    </template>

    <new-criterio-card-inner
      v-if="!hasMultipleGroups"
      :criterio="criterio"
      :is-dragged="isDragged"
      :show-badge="showBadge"
      @dragstart="$emit('dragstart', criterio, group)"
      @dragend="$emit('dragend')"
      @dblclick="$emit('add-criteria', criterio, group, 0)"
    />

    <v-list v-if="hasMultipleGroups">
      <v-list-item v-for="(groupToSelect, groupIndex) in segmentationGroups" :key="groupIndex" @click="$emit('add-criteria', criterio, group, groupIndex)">
        <v-list-item-title>Grupo {{ groupIndex + 1 }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </component>
</template>

<script>
export default {
  components: {
    NewCriterioCardInner: () => import('./NewCriterioCardInner.vue'),
  },
  props: {
    criterio: {
      type: Object,
      required: true,
    },
    group: {
      type: Object,
      required: true,
    },
    segmentationGroups: {
      type: Array,
      required: true,
    },
    isDragged: {
      type: Boolean,
      default: false,
    },
    showBadge: {
      type: Boolean,
      default: false,
    },
    hasMultipleGroups: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
